import React from "react";
import leftPng from "../../../../content/images/left.png";

const Detail = () => {
  return (
    <div id="detailSide" className="d-none">
      <div className="detail-title">Budget in detail</div>
      <div className="clearfix">
        <div className="float-left mt-4">
          <a id="detail-button" className="back-page-link" role="button">
            <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar Budgetten
          </a>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail-active">
            <div className="box-title-1-active">Gisratio Id</div>
            <div className="box-title-2-active" id="d-algemeen-gisratio" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Status</div>
            <div className="box-title-2" id="d-status" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Naam maatregel</div>
            <div className="box-title-2" id="d-maatregel-naam" />
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Naam budget</div>
            <div className="box-title-2" id="d-budget-naam" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Naam discipline</div>
            <div className="box-title-2" id="d-discipline-naam" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Naam werkplan</div>
            <div className="box-title-2" id="d-werkplan-naam" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Detail;
